var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0206 11.5779L14.8759 14.4326L13.9326 15.3759L11.0779 12.5206C10.0157 13.3721 8.69459 13.8352 7.33325 13.8333C4.02125 13.8333 1.33325 11.1453 1.33325 7.83325C1.33325 4.52125 4.02125 1.83325 7.33325 1.83325C10.6453 1.83325 13.3333 4.52125 13.3333 7.83325C13.3352 9.19459 12.8721 10.5157 12.0206 11.5779ZM10.6833 11.0833C11.5291 10.2131 12.0016 9.04683 11.9999 7.83325C11.9999 5.25525 9.91125 3.16659 7.33325 3.16659C4.75525 3.16659 2.66659 5.25525 2.66659 7.83325C2.66659 10.4113 4.75525 12.4999 7.33325 12.4999C8.54683 12.5016 9.71306 12.0291 10.5833 11.1833L10.6833 11.0833Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f3ad1598e6697cdd94c00e774524aae9.svg";
export { ForwardRef as ReactComponent };